import React from 'react';
//import LeftPanel from './security/LeftPanel';
import MainPanel from './security/MainPanel';

export default class Security extends React.Component {
	render() {
		return (
			<MainPanel />
		);
	}
}


// WEBPACK FOOTER //
// ./app/components/SecurityHome.js